import {
  Bar,
  BarChart,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis
} from 'recharts';
import { StyledRecharts } from './Recharts.styled';

const MethodologyRoles: React.FC = () => {
  const data = [
    { language: 'Backend Developer', value: 16.718685589776808 },
    { language: 'Full-stack Developer', value: 13.444437901183676 },
    { language: 'Frontend Developer', value: 12.513986219892821 },
    { language: 'Tech Lead', value: 4.4697014310111305 },
    {
      language: 'DevOps, Infrastructure & SRE',
      value: 3.5745833578705613
    },
    { language: 'Software Architect', value: 3.3331370355102763 },
    {
      language: 'Project & Delivery Manager',
      value: 3.1918026029091338
    },
    { language: 'Engineering Manager', value: 2.650020611271421 },
    { language: 'Mobile Developer', value: 2.514575113361993 },
    { language: 'Data Engineer', value: 2.320240268535422 }
  ];

  return (
    <div>
      <StyledRecharts className="methodology">
        <ResponsiveContainer width={380} height={310}>
          <BarChart data={data} layout="vertical">
            <XAxis
              type="number"
              allowDecimals={false}
              tickLine={false}
              padding={{ left: 5 }}
              tickFormatter={(tick) => {
                return `${tick}%`;
              }}
            ></XAxis>
            <YAxis
              type="category"
              dataKey="language"
              tickLine={false}
              width={140}
            />
            <Tooltip
              cursor={{ fill: 'transparent' }}
              labelStyle={{ display: 'none' }}
              separator=""
              formatter={(value: number) => [value.toFixed(1) + '%', '']}
              wrapperClassName="tooltip-y"
            />
            <Bar dataKey="value" fill="#4292C6" barSize={8} radius={5} />
          </BarChart>
        </ResponsiveContainer>
      </StyledRecharts>
    </div>
  );
};

export default MethodologyRoles;
